/** Host „podglądowy” po migracji produkcji na app2.unitresco.com */
export const LEGACY_PREVIEW_HOSTNAME = 'app.unitresco.com';

export const LEGACY_HOST_BANNER_HEIGHT_VAR = '--legacy-host-banner-height';

export function isLegacyPreviewHost(hostname: string = typeof window !== 'undefined' ? window.location.hostname : ''): boolean {
  return hostname === LEGACY_PREVIEW_HOSTNAME;
}
